import { render, staticRenderFns } from "./form.vue?vue&type=template&id=6a37a9a3"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a37a9a3')) {
      api.createRecord('6a37a9a3', component.options)
    } else {
      api.reload('6a37a9a3', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=6a37a9a3", function () {
      api.rerender('6a37a9a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/brand/form.vue"
export default component.exports